import { Confirmation, ToastMessageOptions } from "primeng/api";

export enum ALERT_SERVICE {
  confirm = "alert:confirm",
  toast = "alert:toast",
  upgrade = "alert:upgrade",
}

export type AlertConfirm = Confirmation & {
  destructive?: boolean;
};

export type AlertToast = ToastMessageOptions;
